// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Logo-CssProp1_svg-module--cls1--1ybCI","cls2":"Logo-CssProp1_svg-module--cls2--1Da4f Logo-CssProp1_svg-module--cls1--1ybCI"};